import React, { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { DEFAULT_THEME_COLOR } from 'appenv';
import styled from 'styled-components';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import FilterOptionContainer from './FilterOptionContainer';

const CustomCheckbox = ({ color, children, ...props }: any) => {
  const Custom = withStyles({
    root: {
      width: '42px',
      padding: '0 9px',
      verticalAlign: 'top',
      marginRight: '7px',
      color: '#A2AAB3',
      '&$checked': {
        color,
      },
    },
    checked: {},
  })(Checkbox);
  return <Custom {...props as any}>{children as any}</Custom>;
};

const StyledLabel = styled.label`
  display: inline-block;
  width: calc(100% - 50px);
  font-size: 14px;
  line-height: 20px;
  color: #484848;
  cursor: pointer;
`;

const FilterCheckboxOption = ({
  label,
  questionId,
  choiceId,
  onClick,
  checked = false,
  hasSubQuestions,
}: {
  label: string;
  questionId: string;
  choiceId: string;
  checked: boolean;
  onClick: (questionId: string, choiceId: string, hasSubQuestions: boolean) => void;
  hasSubQuestions: boolean;
}) => {
  const { themeColor } = useSelector((s: any) => s.eventConfigs);
  const resolvedColor = themeColor || DEFAULT_THEME_COLOR;
  const uuid = useMemo(() => uuidv4(), []);
  const onCheckboxClick = (event: React.MouseEvent) => {
    // eslint-disable-next-line
    // @ts-ignore
    onClick(questionId, choiceId, hasSubQuestions);
  };
  return (
    <FilterOptionContainer selected={checked} color={resolvedColor}>
      <CustomCheckbox
        id={uuid}
        onClick={onCheckboxClick}
        checked={checked}
        color={resolvedColor}
      />
      <StyledLabel htmlFor={uuid}>{label}</StyledLabel>
    </FilterOptionContainer>
  );
};

export default FilterCheckboxOption;
